import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { useAppType } from "./contexts/AppTypeContext";

// lazy imports
const Layout = lazy(() => import("./components/Layout").then(m => ({ default: m.Layout })));
const Home = lazy(() => import("./components/Home").then(m => ({ default: m.Home })));
const MypageLogin = lazy(() => import("./components/MypageLogin"));
const Redirect = lazy(() => import("./components/RedirectPage"));
const DiagnosisLayout = lazy(() => import("./components/Diagnosis/Layout"));
const DiagnosisAge = lazy(() => import("./components/Diagnosis/1_Age"));
const DiagnosisIncome = lazy(() => import("./components/Diagnosis/2_AnnualIncome"));
const DiagnosisAssets = lazy(() => import("./components/Diagnosis/3_FinancialAssets"));
const InvestmentPurpose = lazy(() => import("./components/Diagnosis/4_InvestmentPurpose"));
const DropResponding = lazy(() => import("./components/Diagnosis/5_DropResponding"));
const HealthCheck = lazy(() => import("./components/Diagnosis/6_HealthCheck"));
const PreventiveMedicine = lazy(() => import("./components/Diagnosis/7_PreventiveMedicine"));
const HappinessIndex = lazy(() => import("./components/Diagnosis/8_HappinessIndex"));
const DiagnosisResult = lazy(() => import("./components/DiagnosisResult"));
const PremiumResult = lazy(() => import("./components/PremiumResult"));

const routesConfig = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "home", element: <Home /> },
      { path: "redirect", element: <Redirect /> },
      {
        path: "diagnosis",
        element: <DiagnosisLayout />,
        children: [
          { path: "age", element: <DiagnosisAge /> },
          { path: "annual_income", element: <DiagnosisIncome /> },
          { path: "financial_assets", element: <DiagnosisAssets /> },
          { path: "investment_purpose", element: <InvestmentPurpose /> },
          { path: "drop_responding", element: <DropResponding /> },
          { path: "health_check", element: <HealthCheck /> },
          { path: "preventive_medicine", element: <PreventiveMedicine /> },
          { path: "happiness_index", element: <HappinessIndex /> }
        ],
      },
      { path: "diagnosis_result", element: <DiagnosisResult /> },
      { path: "premium_result", element: <PremiumResult /> }
    ],
  },
];

const renderRoutes = (routesConfig) =>
  routesConfig.map((route, idx) => {
    const { children, ...routeProps } = route;
    return (
      <Route key={idx} {...routeProps}>
        {children && renderRoutes(children)}
      </Route>
    );
  });

export function AppRoutes() {
  const { isGic, loaded } = useAppType();
  if (!loaded) return null;

   // index route を動的に置き換え
  const routes = routesConfig.map(route => {
    if (route.path === "/" && route.children) {
      const updatedChildren = route.children.map(child => {
        if (child.index) {
          return { ...child, element: isGic ? <Home /> : <MypageLogin /> };
        }
        return child;
      });
      return { ...route, children: updatedChildren };
    }
    return route;
  });

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>{renderRoutes(routes)}</Routes>
    </Suspense>
  );
}
